<template :key="$route.path">
    <div :class="'catalog-'+this.$attrs.catalogType">
            <v-row class="filter-container">
                <v-select
                        class="sort-select"
                        :items="sortOptions"
                        label="Sort by"
                ></v-select>
            </v-row>
            <v-row v-if="loading" class="loading">
                <Loading></Loading>
            </v-row>
            <v-row v-if="titles" class="content">
                <title-tile
                        v-for="title of titles"
                        v-bind:key="title.imdb_id"
                        v-bind:id="title.imdb_id"
                        v-bind:image="title.images && title.images.poster"
                        v-bind:year="title.year"
                        v-bind:title="title.title"
                        v-bind:seasons="title.num_seasons"
                        v-bind:rating="title.rating.percentage*5/100"
                        v-bind:basePath="'/'+$attrs.catalogType"
                >
                </title-tile>
            </v-row>
            <v-row v-if="fetchingNewPage" class="loading">
                <Loading></Loading>
            </v-row>
    </div>
</template>
<style>
    body{
        background: #303030;
    }
    .content{
        display: flex;
        flex-flow: wrap;
        justify-content: center;
    }
    .filter-container{
        display: flex;
        flex-flow: wrap;
        justify-content: flex-end;
    }
    .loading{
        font-size: 20px;
        margin-top: 20px;
        display: flex;
        flex-flow: wrap;
        justify-content: center;
    }
    .sort-select{
        display: none;
        max-width: 150px;
    }
    .v-list-item__title{
        text-transform: capitalize;
    }
</style>
<script>
    import TitleTile from '@/components/TitleTile';
    import Loading from '@/components/Loading';
    import axios from 'axios';

    export default {
        components: {
            TitleTile,
            Loading
        },
        data() {
            return {
                loading: false,
                titles: null,
                error: null,
                page: 1,
                fetchingNewPage: false,
                scrolledToBottom: false,
                sortOptions: [
                    'trending',
                    'last added',
                    'rating',
                    'title',
                    'year'
                ]
            }
        },
        created() {
            if(this.$attrs.catalogType === 'movie'){
                document.title = ' - Movies - MaikaElev';
            }else{
                document.title = ' - TV Shows - MaikaElev';
            }

            this.fetchData();
        },
        mounted() {
            this.scroll();
        },
        watch: {
            '$route': 'routeChange'
        },
        methods: {
            debug (log){
                console.log(log)
            },
            scroll () {
                window.onscroll = () => {
                    let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
                    if (bottomOfWindow && !this.fetchingNewPage && !this.loading) {
                        this.page++;
                        this.fetchingNewPage = true;
                        this.fetchData(true);
                    }
                }
            },
            routeChange: function (){
                this.loading= false;
                this.titles= null;
                this.fetchData();
            },
            mapMoviesResults: function(titles){
                //return titles; POPCorn

                return this._.map(titles, function mapMovies(movie){
                    return {
                        imdb_id: movie.imdb_code,
                        images: {
                            poster: movie.medium_cover_image
                        },
                        year: movie.year,
                        title: movie.title,
                        rating: {
                            percentage: movie.rating*10
                        }
                    }
                })
            },
            mapShowResults: function(titles){
                return titles;
                /*
                return this._.map(titles, function mapMovies(show){
                    return {
                        imdb_id: show.show.ids.imdb,
                        images: {
                            poster: ''
                        },
                        year: show.show.year,
                        title: show.show.title,
                        rating: {
                            percentage: show.show.rating*10
                        }
                    }
                })
                */
            },
            fetchData(appendResults) {
                var self = this;
                var params = this.$route.query;
                const catalogType = this.$attrs.catalogType;
                this.error = null;

                if(!appendResults){
                    this.loading = true;
                    this.titles = {};
                }


                /* POPCORN
                if(catalogType === 'movie'){
                    params.sort = 'trending'
                }
                */
                if(catalogType === 'movie'){
                    params.sort_by = 'year';
                    params.with_rt_ratings = true;
                    params.page = this.page;
                    params.limit = 40;
                    params.query_term = params.keywords;
                    if(params.keywords){
                        params.sort_by = 'year';
                        params.page = 1;
                    }
                }

                let url = '';
                if(catalogType === 'movie'){
                  /* POPCORN
                    url = '//api.maikaelev.com/popxy/movies/' + this.page;
                    axios.get(url,{
                        params: params
                    }).then(function (response) {
                        //self.titles = self._.uniqBy(self._.union(self.titles,self.mapMoviesResults(response.data.data.movies)),'imdb_id');
                        self.titles = self._.uniqBy(self._.union(self.titles,self.mapMoviesResults(response.data)),'imdb_id');
                        if(appendResults){
                            self.fetchingNewPage = false;
                        }else{
                            self.loading = false;
                        }
                    })
                    */
                    url = 'https://yts.mx/api/v2/list_movies.json'
                    axios.get(url,{
                        params: params
                    }).then(function (response) {
                        self.titles = self._.uniqBy(self._.union(self.titles,self.mapMoviesResults(response.data.data.movies)),'imdb_id');
                        if(appendResults){
                            self.fetchingNewPage = false;
                        }else{
                            self.loading = false;
                        }
                    })

                }else{
                    url = '//api.maikaelev.com/popxy/shows/' + this.page;
                    axios.get(url,{
                        params: params
                    }).then(function (response) {
                        self.titles = self._.uniqBy(self._.union(self.titles,self.mapShowResults(response.data)),'imdb_id');
                        if(appendResults){
                            self.fetchingNewPage = false;
                        }else{
                            self.loading = false;
                        }
                    })
                }
            }
        }
    }
</script>